export default Object.freeze({
  ACTION: 'action',
})
